import { formatNumber } from '../formula/CodeWindow';

export const reportCalculateTotals = (data, columns) => {
  const totals = {};

  columns?.forEach((col) => {
    // Ensure the correct check for 'S.N.', 'SN', 'S N'
    if (['S.N.', 'SN', 'S N', 'S.N.', 'sn'].includes(col.dataIndex)) {
      totals[col.dataIndex] = 'Total'; // Place 'Total' only in this column
    } else {
      // Skip summing for non-numeric columns
      if (
        [
          'Order Code',
          'orderDate',
          'Item Code',
          'Purity',
          'Item Name',
          'Action',
          'Date',
          'Party',
          'Transaction Type',
          'INV No.',
          'Party Name',
          'Item',
          'Code',
          'Issue Date',
          'Receive Date',
          'Issue Bill No.',
          'Issue To',
          'Receive Sales Amount',
          'Receive profit %',
          'Particular',
          'Voucher Type',
          'Voucher Number',
          'Entry Date',
          'Bill Number',
          'Entry Number',
          'Ledger Name',
          'Ref. No.',
          'Reference Code',
          'English Date',
          'Nepali Date',
          'Agent Name',
          'Bill No.',
          'Ref. Code',
          'Order Date',
          'Status',
          'MRP Amount',
          'sales_date',
          'buyer_pan_no',
          'refNo'
        ].includes(col?.dataIndex)
      ) {
        totals[col?.dataIndex] = '';
      } else {
        // Sum numeric values
        const totalValue = data?.reduce((sum, row) => {
          const cellValue = row[col?.dataIndex];
          return cellValue === null || cellValue === undefined
            ? sum // Skip null or undefined values
            : sum + (Number(cellValue) || 0); // Convert to number, defaulting to 0 for non-numeric values
        }, 0);

        // Format numbers accordingly
        totals[col.dataIndex] = formatNumber(totalValue, 3);
      }
    }
  });

  return totals;
};

// export const reportCalculateTotalsForParentTime = (data, columns) => {
//   const totals = {};

//   const calculateColumnTotal = (col, parentDataIndex = null) => {
//     if (col.children) {
//       // If the column has children, recursively process them
//       col.children.forEach((child) =>
//         calculateColumnTotal(child, col.dataIndex),
//       );
//     } else {
//       // If it's a leaf column (child), sum up the values
//       const isExcluded = [
//         'Order Code',
//         'Item Code',
//         'Purity',
//         'Item Name',
//         'Action',
//         'Date',
//         'Party',
//         'Transaction Type',
//         'INV No.',
//         'Party Name',
//         'Item',
//         'Code',
//         'Issue Date',
//         'Receive Date',
//         'Issue Bill No.',
//         'Issue To',
//         'Receive Sales Amount',
//         'Receive profit %',
//         'Particular',
//         'Voucher Type',
//         'Voucher Number',
//         'Voucher',
//         'Vch No',
//         'Issue Name',
//       ].includes(col?.dataIndex);

//       if (isExcluded) {
//         totals[col.dataIndex] = '';
//       } else {
//         const totalValue = data?.reduce((sum, row) => {
//           const cellValue = row[col?.dataIndex];
//           return cellValue === null || cellValue === undefined
//             ? sum // Skip null or undefined values
//             : sum + (Number(cellValue) || 0); // Convert to number and add
//         }, 0);

//         // Store total only for child columns
//         totals[col.dataIndex] =
//           col.dataIndex === 'Set Pcs'
//             ? totalValue // Keep original format for 'Set Pcs'
//             : totalValue.toFixed(3); // Apply .toFixed(3) for others
//       }
//     }
//   };

//   columns?.forEach((col) => calculateColumnTotal(col));

//   return totals;
// };
export const reportCalculateTotalsForParentTime = (data, columns) => {
  const totals = {};

  const calculateColumnTotal = (col, parentDataIndex = null) => {
    if (col.children) {
      // If the column has children, recursively process them
      col.children.forEach((child) =>
        calculateColumnTotal(child, col.dataIndex),
      );
    } else {
      // If it's a leaf column (child), sum up the values
      if (['S.N.', 'SN', 'S N', 'S.N.'].includes(col.dataIndex)) {
        totals[col.dataIndex] = 'Total'; // Only add "Total" for these columns
      } else {
        const isExcluded = [
          'Order Code',
          'Item Code',
          'Purity',
          'Item Name',
          'Action',
          'Date',
          'Party',
          'Transaction Type',
          'INV No.',
          'Party Name',
          'Item',
          'Code',
          'Issue Date',
          'Receive Date',
          'Issue Bill No.',
          'Issue To',
          'Receive Sales Amount',
          'Receive profit %',
          'Particular',
          'Voucher Type',
          'Voucher Number',
          'Voucher',
          'Vch No',
          'Issue Name',
          'Order Date',
          'Ref .No.',
          'Bill No.',
          'Agent Name',
          'rate',
          'agent_name',
          'sales_date',
          'entry_no',
          'party_name',
          'party_mobile_number',
          'item_name',
          'item_code',
          'bill_no',
          'purity',
          'ref_no',
        ].includes(col?.dataIndex);

        if (isExcluded) {
          totals[col.dataIndex] = '';
        } else {
          const totalValue = data?.reduce((sum, row) => {
            const cellValue = row[col?.dataIndex];
            return cellValue === null || cellValue === undefined
              ? sum // Skip null or undefined values
              : sum + (Number(cellValue) || 0); // Convert to number and add
          }, 0);

          // Store total only for child columns
          totals[col.dataIndex] = formatNumber(totalValue, 3);
        }
      }
    }
  };

  columns?.forEach((col) => calculateColumnTotal(col));

  return totals;
};

export const reportCalculateTotalsLength = (data, key) => {
  const isExcluded = [
    'Order Code',
    'Item Code',
    'Purity',
    'Item Name',
    'Action',
    'Date',
    'Party',
    'Transaction Type',
    'INV No.',
    'Party Name',
    'Item',
    'Code',
    'Issue Date',
    'Receive Date',
    'Issue Bill No.',
    'Issue To',
    'Receive Sales Amount',
    'Receive profit %',
    'Particular',
    'Voucher Type',
    'Voucher Number',
    'Voucher',
    'Vch No',
    'Issue Name',
    'Order Date',
    'Ref .No.',
    'Bill No.',
    'Agent Name',
  ].includes(key);

  if (isExcluded) {
    return 0;
  } else if (key.includes('S.N.')) {
    return 6;
  } else {
    const length = data
      ?.reduce((sum, value) => {
        if (isNaN(value)) return sum;
        return sum + Number(value);
      }, 0)
      .toLocaleString().length;
    return length;
  }
  return 0;
};
